import { render, staticRenderFns } from "./EpisodeList.vue?vue&type=template&id=bab911fa&scoped=true&"
import script from "./EpisodeList.vue?vue&type=script&lang=js&"
export * from "./EpisodeList.vue?vue&type=script&lang=js&"
import style0 from "./EpisodeList.vue?vue&type=style&index=0&id=bab911fa&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bab911fa",
  null
  
)

export default component.exports